import { API, authClient } from "../index";

export const postCreateCheckoutSession = async (obj) => {
  return authClient().post(`${API}/stripe/create-checkout-session`, obj);
};

export const postCreatePaymentIntent = async (obj) => {
  return authClient().post(`${API}/stripe/payment-intents`, obj);
};

// Pago en un toque (tiper identificado con tarjeta guardada).
// Cobra la propina off-session con la tarjeta guardada. Respuesta:
// { status: "succeeded" } | { status: "requires_action", clientSecret, paymentMethodId }
// o 402 { status: "failed", message } → se vuelve al PaymentElement.
export const postOneTapPayment = async (obj) => {
  return authClient().post(`${API}/stripe/payment-intents/one-tap`, obj);
};

// Marca (save=true) o quita (save=false) el guardado de la tarjeta en el
// PaymentIntent pendiente: customer + setup_future_usage solo para tarjeta.
export const postPaymentIntentSaveCard = async (paymentIntentId, obj) => {
  return authClient().post(
    `${API}/stripe/payment-intents/${paymentIntentId}/save-card`,
    obj,
  );
};

// Tras pagar con la casilla marcada: el backend deja la cookie HttpOnly
// tiper.pay que autoriza a este navegador a pagar en un toque.
export const postOneTapToken = async (paymentIntentId, obj) => {
  return authClient().post(
    `${API}/stripe/payment-intents/${paymentIntentId}/one-tap-token`,
    obj,
  );
};

// Pago exprés (Apple Pay / Google Pay en la primera pantalla). Crea o
// reutiliza el PaymentIntent de la propina con el importe calculado en
// servidor; 409 AMOUNT_MISMATCH si no coincide con expectedAmountCents.
// Respuesta: { clientSecret, paymentIntentId, amountCents, reused }
export const postExpressPaymentIntent = async (obj) => {
  return authClient().post(`${API}/stripe/payment-intents/express`, obj);
};

export const getSessionStatus = async (sessionId) => {
  return authClient().get(`${API}/stripe/${sessionId}`);
};
